import { $api } from '../y/api';
import { YId, YTimeString } from '../y/types';

export type MCode = string & { __type: 'MCode' };
export type MChannel = 'sms' | 'push' | 'email' | 'inbox';
export type MDeliveryStatus = 'queued' | 'sent' | 'failed' | 'delivered' | 'bounced' | 'complaint';

export interface MMessage {
    id: YId;
    code: MCode;
    communication_id: YId;
    channel: MChannel;
    metadata: { [key: string]: string };
    display_to: string;
    display_name: string;
    deliveries: { status: MDeliveryStatus }[];
    body_hash?: string;
    created_at: YTimeString;
    open_at?: YTimeString;
}

export interface MDeliveryMessage {
    code: MCode;
    channel: MChannel;
    display_to: string;
    display_name: string;
    body_hash?: string;
    created_at: YTimeString;
    open_at?: YTimeString;
}

export interface MDelivery {
    id: YId;
    message_id: YId;
    dst_kind: string;
    dst_endpoint: string;
    status: MDeliveryStatus;
    sent_at?: YTimeString;
    delivered_at?: YTimeString;
    message: MDeliveryMessage;
}

export function mMessagesGetLast() {
    return $api.GET<MMessage[]>('messages/last');
}
